<template>
    <div class="table-responsive">
        <table class="table border" v-if="listLength > 0">
          <thead class="thead-light">
            <tr>
              <th
                scope="col"
                class="p-1 text-uppercase font-weight-bold align-middle"
                width="10%"
                :style="customTableHeaderColorStyle"
              >
                  qty
              </th>
              <th
                scope="col"
                class="p-1 font-weight-bold align-middle"
                width="40%"
                :style="customTableHeaderColorStyle"
              >
                  Bin type & size
              </th>
              <th
                scope="col"
                class="p-1 text-capitalize font-weight-bold align-middle"
                width="20%"
                :style="customTableHeaderColorStyle"
              >
                  Frequency
              </th>
              <th
                scope="col"
                class="p-1 font-weight-bold align-middle"
                width="30%"
                :style="customTableHeaderColorStyle"
              >
                  Upcoming collection date
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(wSValue, wasteStreamBinSize) in listObject" :key="wasteStreamBinSize">
              <td class="p-1 ">{{ wSValue.binQuantity }}</td>
              <td class="p-1 text-uppercase">{{ wSValue.binSize + ' ' + wSValue.displayName }}</td>
              <td class="p-1 ">{{ wSValue.displayFrequency }}</td>
                <td class="p-1 ">
                    <span class="text-capitalize">{{ wSValue.dayShort }},</span>
                    <span>{{ wSValue.nearestCollectionDate }}</span>
                </td>
            </tr>
          </tbody>
        </table>
    </div>
</template>

<script>
    import DateNoTz from '../utils/DateNoTz';
    export default {
        props: {
            list: {
                type: Object
            },
            customTableHeaderColorStyle: {
                type: String,
                default: ''
            }
        },
        methods: {
            formatDate(schedule) {
                const d = new DateNoTz(schedule);
                return `${d.getDateWithZero()} ${d.getMonthDescShort()} ${d.getFullYear()}`
            }
        },
        computed: {
            listObject() {
                const listCopy = { ...this.list };
                for (let p in listCopy) {
                    if (listCopy[p].items.length < 1) {
                        continue;
                    }
                    const singleItem = listCopy[p].items[0];
                    listCopy[p]['binQuantity'] = parseInt((singleItem && singleItem.binQuantity) || 0);
                    listCopy[p]['binType'] = singleItem && singleItem.binType;
                    listCopy[p]['binSize'] = ((singleItem && singleItem.binSize) || 0) + 'L';
                    listCopy[p]['nearestCollectionDate'] = this.formatDate(singleItem.nextCollectionDate);
                    listCopy[p]['dayShort'] = singleItem.dayOfTheWeek.substr(0, 3);
                }
                return listCopy;
            },
            listLength() {
                return Object.keys(this.list).length;
            }
        }
    }
</script>